import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ClientProvider } from '@glyph/core';
import { ToastProvider } from '@glyph/ui';
import '@glyph/ui/styles.css';
import { client } from './client';
import { App } from './App';
import { startBuildWatch } from './update-check';

// A home-screen app resumed days later reloads itself onto the newest build (see update-check.ts).
startBuildWatch();
// Service worker: Web Push only (public/sw.js). Registered early so an existing subscription is found on load.
if ('serviceWorker' in navigator && location.protocol === 'https:') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ClientProvider client={client}>
      <ToastProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ToastProvider>
    </ClientProvider>
  </React.StrictMode>,
);
